document.addEventListener("DOMContentLoaded", () => {
  const sticky = document.getElementById("sticky_menu");
  const thresholdEl = document.querySelector("[data-sticky-threshold]");

  if (!sticky) return;

  const menuItems = Array.from(sticky.querySelectorAll(".menu_item[data-id]"));

  // data-sticky-threshold を超えたらメニュー表示
  let threshold = 0;

  const normalizePath = (pathname) => {
    const p = pathname.replace(/\/$/, "") || "/";
    return p === "" ? "/" : p;
  };

  // 「お役立ち情報」親リンクの実URLからベースパスを取得（環境差異に強くする）
  const infoParentLink = sticky.querySelector('.menu_item[data-id="info"]:not(.-sub)');
  const infoBasePath = infoParentLink
    ? normalizePath(new URL(infoParentLink.href).pathname)
    : "/info";

  /** お役立ち情報のアーカイブ or 個別（info 親リンク配下） */
  const isInfoContextPath = (pathname) => {
    const p = normalizePath(pathname);
    return p === infoBasePath || p.startsWith(`${infoBasePath}/`);
  };

  /** アーカイブ1ページ目 /info とページ送り /info/page/2 …（個別 /info/slug とは別） */
  const isInfoArchivePath = (pathname) => {
    const p = normalizePath(pathname);
    if (p === infoBasePath) return true;
    return p.startsWith(`${infoBasePath}/page/`);
  };

  /** 個別記事本文に出ているカテゴリ slug（.c_cat_tag.-cat_* から） */
  const getInfoTxoFromDom = () => {
    const el = document.querySelector('[class*="c_cat_tag"][class*="-cat_"]');
    if (!el) return null;
    const m = el.className.match(/-cat_([^\s]+)/);
    return m ? m[1] : null;
  };

  /**
   * アンカーの href と現在URLが同一ページか（パス・リンク側のクエリ・ハッシュ）
   */
  const linkMatchesCurrentPage = (anchor) => {
    const u = new URL(anchor.href);
    const c = new URL(window.location.href);
    if (normalizePath(u.pathname) !== normalizePath(c.pathname)) return false;
    if (u.search) {
      const ps = new URLSearchParams(u.search);
      for (const [k, v] of ps) {
        if (c.searchParams.get(k) !== v) return false;
      }
    }
    if (u.hash) {
      return c.hash === u.hash;
    }
    return true;
  };

  const applyActiveFromUrl = () => {
    // 毎回いったん解除してから、現在URLに一致する項目だけを付与
    menuItems.forEach((a) => a.classList.remove("-active"));

    const loc = window.location;
    const currentUrl = new URL(window.location.href);
    const curPath = normalizePath(loc.pathname);
    const curTxo = currentUrl.searchParams.get("info_txo");

    for (const a of menuItems) {
      const isSub = a.classList.contains("-sub");
      const txo = a.dataset.infoTxo;

      if (isSub && txo) {
        // アーカイブ + ?info_txo=…（/info/page/2?… のページ送りも含む）
        if (isInfoArchivePath(curPath) && curTxo === txo) {
          a.classList.add("-active");
          continue;
        }
        // /info/{post-slug} の個別記事（本文のカテゴリ表示から判定）
        if (isInfoContextPath(loc.pathname) && !isInfoArchivePath(curPath)) {
          const domSlug = getInfoTxoFromDom();
          if (domSlug === txo) {
            a.classList.add("-active");
          }
        }
        continue;
      }

      if (a.dataset.id === "info" && !isSub) {
        // お役立ち情報配下では親タブを常にアクティブ
        if (isInfoContextPath(loc.pathname)) {
          a.classList.add("-active");
        }
        continue;
      }

      if (linkMatchesCurrentPage(a)) {
        a.classList.add("-active");
      }
    }
  };

  const computeThreshold = () => {
    if (thresholdEl) {
      const rect = thresholdEl.getBoundingClientRect();
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      threshold = rect.top + scrollY + rect.height;
    } else {
      threshold = 0;
    }
  };

  const applyState = () => {
    // 表示/非表示のみをスクロールで制御（アクティブ判定はURLベース）
    const y = window.pageYOffset || document.documentElement.scrollTop;
    if (y >= threshold) {
      sticky.classList.add("-show");
    } else {
      sticky.classList.remove("-show");
    }
  };

  computeThreshold();
  applyState();
  applyActiveFromUrl();

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      applyState();
      ticking = false;
    });
  };

  window.addEventListener("scroll", onScroll, { passive: true });

  const recalc = () => {
    computeThreshold();
    applyState();
  };
  window.addEventListener("resize", recalc);
  window.addEventListener("load", recalc);

  if (thresholdEl && "ResizeObserver" in window) {
    try {
      const ro = new ResizeObserver(recalc);
      ro.observe(thresholdEl);
    } catch (e) {
      // noop
    }
  }
});
